/**
 * Rails CSRF token from <meta name="csrf-token"> (csrf_meta_tags in the layout).
 *
 * Send it as X-CSRF-Token on every POST/PATCH/DELETE: controllers on ApplicationController reject
 * requests without it, and Api::V1::BaseController ignores it, so it's always safe to send.
 */
export const csrfToken = (): string =>
  document.querySelector<HTMLMetaElement>('meta[name="csrf-token"]')?.content ?? '';
